import { render, staticRenderFns } from "./ArrobaMedellinAppBar.html?vue&type=template&id=97160d96&scoped=true&"
import script from "./ArrobaMedellinAppBar.vue?vue&type=script&lang=js&"
export * from "./ArrobaMedellinAppBar.vue?vue&type=script&lang=js&"
import style0 from "./ArrobaMedellinAppBar.scss?vue&type=style&index=0&id=97160d96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97160d96",
  null
  
)

export default component.exports